<template>
  <div class="introduce">
    <img v-for="(item, index) in images" :key="index" :src="item" @click="preview(images, index)" />
  </div>
</template>

<script>
import p1 from '@/assets/img/001.jpg';
import p2 from '@/assets/img/002.jpg';
import p3 from '@/assets/img/003.jpg';

import { ImagePreview } from 'vant';

export default {
  name: '',
  data() {
    return {
      images: [p1, p2, p3],
      iframeSrc: '',
      loading: true
    };
  },
  methods: {
    preview(images, startPosition) {
      ImagePreview({
        images,
        startPosition
      });
    }
  },
  mounted() {
    // 可以在这里添加一些iframe加载后的操作
  }
};
</script>

<style lang="scss" scoped>
.introduce {
  background: #fff;
  padding-right: 5px;
  img {
    width: 100%;
  }
}
</style>
